module.exports = __webpack_public_path__ + "img/story-2.a6e729f5.png";